import React from 'react';

import { FullWidthContainer } from './Containers';
import { PreviewImage } from './PreviewImage';
import { getWindow } from '../globals';

export class FullWidthImage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      height: '60vh',
    };
  }

  componentDidMount() {
    let window = getWindow();
    if (window) {
      this.setState({
        height: window.innerHeight * 0.6 + 'px',
      });
    }
  }

  render() {
    const { image, className, ...restProps } = this.props;
    if (!image) {
      return null;
    }

    const { preview, aspectRatio } = image;

    return (
      <FullWidthContainer className={className}>
        <PreviewImage
          src={image.url}
          alt={image.alt}
          cloudinaryOptions={image.cloudinary}
          aspectRatio={aspectRatio}
          preview={preview}
          height={this.state.height}
          {...restProps}
        />
      </FullWidthContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/FullWidthImage.js